export type RiskQLabels = {
	caption: string;
	description: string;
	language1Caption: string | null;
	language1Description: string | null;
	language2Caption: string | null;
	language2Description: string | null;
};

export type Questionnaire = RiskQLabels & {
	customerType: 'Individual' | 'IndividualOrCompany' | 'Company';
	id: number;
	questionGroups: QuestionGroup[];
	testType: 'Appropriateness' | 'Suitability';
	version: number;
};

export type QuestionGroup = RiskQLabels & {
	id: number;
	ordering: number;
	questions: RiskQuestion[];
	testId: number;
};

export type RiskQuestion = RiskQLabels & {
	choices: RiskChoice[];
	dependencyChoiceIds: number[];
	dependsOnQuestionId: null | number;
	id: number;
	isRequired: boolean;
	ordering: number;
	parentId?: number;
	questionType: QuestionType;
	subQuestions: RiskQuestion[];
};

export type RiskChoice = QuestionGroup & {
	maxRiskProfileId?: number;
	questionId: number;
	riskProfileIds: number[];
};

export type ChoiceProps = RiskChoice & {
	className?: string;
	testId: number;
};

export enum QuestionType {
	CheckboxList = 'CheckboxList',
	RadioList = 'RadioList',
	RadioMatrix = 'RadioMatrix'
}

export type QuestionProps = RiskQuestion & {
	isSubquestion?: boolean;
	testId: number;
};

export type Answer = {
	choiceId: number;
	questionId: number;
	testId: number;
	textValue: null | string;
};

export type RiskProfile = {
	description: string;
	id: number;
	name: string;
};

export type RiskQResults = {
	activeRiskProfile: RiskProfile;
	lastTestDate: string;
	previousRiskProfile: RiskProfile;
	recomendedRiskProfile: RiskProfile;
	riskProfilesAvaliableForUser: RiskProfile[];
	riskRenewalUrl: string;
};

export type FORMELEMENT = HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement;
